import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { BusinessLegalProtectionType } from 'src/app/_enums/business/business-legal-protection-type.enum';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import {
  BUSINESS_INSURANCE_PAYMENT_FREQUENCY,
  getPaymentFrequencyLabel,
} from 'src/app/_enums/payment-frequency.enum';

import { LeadFormBase } from '../../lead-form-base';

@Component({
  selector: 'app-business-legal-protection-form',
  templateUrl: './business-legal-protection-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class BusinessLegalProtectionFormComponent
  extends LeadFormBase
  implements OnDestroy, OnInit
{
  @Input()
  formGroup!: FormGroup;

  hasClaimsSub!: Subscription;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.BUSINESS_LEGAL_PROTECTION,
    startDate: [null],
    contractDuration: [null],
    paymentFrequency: [null],
    splitPaymentFee: [null],
    hasclaimsLastFiveYears: [null],
    claims: [null],
    totalSalaries: [null],
    totalRevenue: [null],
    legalProtectionType: [null],

    insurees: this.fb.group({
      companyAndCollaborators: [null],
      partners: [null],
      administrators: [null],
      commiteeMembers: [null],
      contractlessFamilyMembers: [null],
      contractlessFreelanceCollaborateurs: [null],
    }),

    coverages: this.fb.group({
      roadTraffic: [null],
      companyVehiclesCount: [null],
      realEstate: [null],
      insuredSumPerClaim: [null],
      insuredSumContracts: [null],
      deductibleContracts: [null],
      insuredSumInternational: [null],
      earningsLossReimbursement: [null],
      travelExpensesReimbursement: [null],
      companyFurnitureContract: [null],
      taxLaw: [null],
      neighborhoodLaw: [null],
      expropriation: [null],
      customerSupplierContractsLaw: [null],
      damagesClaims: [null],
      criminalLaw: [null],
      administrativeLaw: [null],
      legalAdvice: [null],
      insurancesLaw: [null],
      legalActionLaw: [null],
      tenancyLaw: [null],
      laborLaw: [null],
      professionalAssociationsDisputes: [null],
      interiorTransformation: [null],
      unfairCompetitionDisputes: [null],
      realEstateLaw: [null],
      landCharges: [null],
      constructionPermitOpposition: [null],
      internetProtection: [null],
      imageRights: [null],
      copyrights: [null],
    }),

    territorialCoverages: this.fb.group({
      basicCoverage: [null],
      extendedContractualCoverage: [null],
      accident: [null],
      trip: [null],
      roadTraffic: [null],
      realEstate: [null],
    }),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) {
      this.metadataFormGroup.patchValue(this.metadata);
    }
    this.formGroup.addControl('metadata', this.metadataFormGroup);

    this.hasClaimsSub = this.metadataFormGroup.controls[
      'hasclaimsLastFiveYears'
    ].valueChanges.subscribe((value) => {
      if (value !== 'true' && value !== true) {
        this.metadataFormGroup.controls['claims'].reset();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.hasClaimsSub) this.hasClaimsSub.unsubscribe();
  }

  paymentFrequencyValues = Object.values(BUSINESS_INSURANCE_PAYMENT_FREQUENCY);

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  legalProtectionTypeValues = Object.values(BusinessLegalProtectionType);
}
